import React from 'react'

import classes from './DelegateSelector.scss'

import InputGroup from '../../../../../UI/Forms/InputGroup/InputGroup'
import { updateFormOptions } from '../../../../../../helpers/utils'

import { IconButton } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

const delegateSelector = ({
  addRowClicked,
  inputChanged,
  forms,
  dropdownOptions,
  currentCompany
}) => {
  let formValid = true

  const formData = Object.entries(forms).map(formItem => {
    let [formKey, formAttrs] = formItem

    let groupClass = []
    let inputClass = []

    if (['from_emp_detail_id', 'emp_delegate_id'].includes(formKey)) {
      return null
    }

    if (['input', 'datePicker'].includes(formAttrs.elementType)) {
      inputClass = [classes.FixHeight]
    }

    let formWithOptions = null

    if (formKey === 'position_id') {
      let dropdownFilter =
        dropdownOptions.empOptions.find(emp => emp.emp_id === forms.emp_id.value?.value)
          ?.empdetails || []

      let positionFilter = dropdownFilter.map(res => +res.position_id) || []

      let filteredOptions = dropdownOptions.positionOptions.filter(item =>
        positionFilter.includes(item.position_id)
      )
      formWithOptions = updateFormOptions(
        filteredOptions,
        { ...formAttrs },
        'position_id',
        'position_id',
        'position_name',
        'Select Position',
        false,
        // !clearValue
        false
      )
    } else if (formKey === 'emp_id') {
      let filteredOptions = dropdownOptions.empOptions.filter(
        item => item.company_id === currentCompany
        //  &&
        // (forms.position_id.value ? item.position_id === forms.position_id.value : true)
      )
      // let clearValue = filteredOptions.find(item => item.emp_id === formAttrs.value)
      formWithOptions = updateFormOptions(
        filteredOptions,
        { ...formAttrs },
        'emp_id',
        'emp_id',
        { code: 'emp_code', name: 'full_name' },
        'Select Emp',
        false
        // !clearValue,
        // null
      )
    } else if (formKey === 'is_cancel') {
      formWithOptions.value = !!formWithOptions.value
    } else {
      formWithOptions = { ...formAttrs }
    }

    formValid = formValid && formWithOptions.value && formWithOptions.valid

    return (
      <InputGroup
        key={formKey}
        // overrideClass={overrideClass}
        groupClass={groupClass.join(' ')}
        inputClass={inputClass.join(' ')}
        label={formWithOptions.label}
        inputType={formWithOptions.elementType}
        configs={formWithOptions.elementConfig}
        invalid={!formWithOptions.valid}
        validations={formWithOptions.validation}
        touched={formWithOptions.touched}
        changed={e => inputChanged(formKey, e)}
        inputValue={formWithOptions.value}
        validationError={formWithOptions.error}
        noMargin
      />
    )
  })
  return (
    <div className={classes.RowWrapper}>
      {formData}
      <div className={classes.Button}>
        <IconButton color={'primary'} onClick={addRowClicked} disabled={!formValid}>
          <AddIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default delegateSelector
